<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="realEstate.id">
                                        {{$t("realEstate.edit.title")}}
                                        ({{$t(realEstate.category === 'Residential' ?
                                        'realEstate.category.residential.label' :
                                        'realEstate.category.notorious.label')}})</h4>
                                    <h4 class="card-title float-left" v-else>{{$t("realEstate.add.title")}}
                                        ({{$t(realEstate.category === 'Residential' ?
                                        'realEstate.category.residential.label' :
                                        'realEstate.category.notorious.label')}})</h4>
                                </div>
                                <button class="all-btn pull-right" @click="saveAndGo('coordination')" v-if="canSave">
                                    Мувофиқлаштириш
                                </button>
                                <button class="all-btn add-btn pull-right mr-3" v-if="canSave && realEstate.landComparisonEnabled"
                                        @click="saveAndGo('land')">Ер участкасини хисоблаш
                                </button>
                            </div>
                        </div>
                        <div class="row" v-if="realEstate.status === 'Rejected'">
                            <div class="col">
                                <div class="alert alert-danger">
                                    <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган..
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label>{{$t("realEstate.field.approachMethods")}} <span class="red">*</span></label>
                                        </div>
                                        <div class="col-12">
                                            <div :class="{invalid : $v.realEstate.approach.$error}">
                                                <div class="form-check pl-0 checkbox-inline">
                                                    <label class="form-check-label"
                                                           style="padding-left:22px !important">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachCost">
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.expense")}}
                                                    </label>
                                                </div>
                                                <div class="form-check checkbox-inline">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachIncome"
                                                               @change="onChangeApproach('Income',$event)">
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.income")}}
                                                    </label>
                                                </div>
                                                <div class="form-check checkbox-inline">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachComparative"
                                                               @change="onChangeApproach('Comparative',$event)">
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.comparative")}}
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="red" v-if="$v.realEstate.approach.$error">
                                                {{$t("realEstate.validation.approachMethods")}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.name")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="realEstate.name"
                                           :class="{invalid : $v.realEstate.name.$error}"/>
                                    <div class="red" v-if="$v.realEstate.name.$error">
                                        {{$t("realEstate.validation.name")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.cadastreNumber")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="realEstate.cadastreDocNumber"
                                           :class="{invalid : $v.realEstate.cadastreDocNumber.$error}"/>
                                    <div class="red" v-if="$v.realEstate.cadastreDocNumber.$error">
                                        {{$t("realEstate.validation.cadastreNumber")}}
                                    </div>
                                </div>
                                <div class="form-group"
                                     v-if="realEstate.approachRegression || realEstate.approachComparative">
                                    <label>{{$t("realEstate.field.buildingCategory")}} <span
                                            class="red">*</span></label>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <treeselect class="form-control"
                                                        v-model="realEstate.sectionId"
                                                        placeholder="Танланг..."
                                                        :multiple="false"
                                                        :disable-branch-nodes="true"
                                                        :options="buildingSections"/>
                                        </div>
                                    </div>
                                </div>
                                <div :class="{invalid : $v.realEstate.sections.$error}">
                                    <div class="form-group" v-if="realEstate.approachCost">
                                        <label>{{$t("realEstate.field.cadastreSection")}} <span
                                                class="red">*</span></label>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <treeselect class="form-control" v-model="realEstate.cadastreSections"
                                                            placeholder="Танланг..."
                                                            :options="cadastreSections"
                                                            :multiple="true"
                                                >
                                                </treeselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="red" v-if="$v.realEstate.sections.$error">
                                    {{$t("realEstate.validation.cadastreSection")}}
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.addressAddEdit")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="realEstate.address"
                                           :class="{invalid : $v.realEstate.address.$error}"/>
                                    <div class="red" v-if="$v.realEstate.address.$error">
                                        {{$t("realEstate.validation.addressAddEdit")}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.areaTotal")}} <span class="red">*</span></label>
                                    <numeric-input v-model="realEstate.evlGroundArea" :precision="2"
                                                   :class="{invalid : $v.realEstate.evlGroundArea.$error}"></numeric-input>
                                    <div class="red" v-if="$v.realEstate.evlGroundArea.$error">
                                        {{$t("realEstate.validation.areaTotal")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.areaUnderConstruction")}} <span
                                            class="red">*</span></label>
                                    <numeric-input v-model="realEstate.evlBuildingWidthArea" :precision="2"
                                                   :class="{invalid : $v.realEstate.evlBuildingWidthArea.$error}"></numeric-input>
                                    <div class="red" v-if="$v.realEstate.evlBuildingWidthArea.$error">
                                        {{$t("realEstate.validation.areaUnderConstruction")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.areaUseful")}} <span class="red">*</span></label>
                                    <numeric-input v-model="realEstate.evlUsefulField" :precision="2"
                                                   :class="{invalid : $v.realEstate.evlUsefulField.$error}"></numeric-input>
                                    <div class="red" v-if="$v.realEstate.evlUsefulField.$error">
                                        {{$t("realEstate.validation.areaUseful")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label>{{$t("realEstate.field.valueType")}} <span
                                                    class="red">*</span></label>
                                        </div>
                                        <div class="col-12" :class="{invalid : $v.realEstate.evlValueType.$error}">
                                            <div class="form-check form-check-radio checkbox-inline pl-0"
                                                 style="margin-left:-0.8rem">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="evlValueType"
                                                           value="Market" v-model="realEstate.evlValueType">
                                                    <span class="form-check-sign"></span>
                                                    {{$t("realEstate.valueType.market")}}
                                                </label>
                                            </div>
                                            <div class="form-check form-check-radio checkbox-inline">
                                                <label class="form-check-label">
                                                    <input class="form-check-input" type="radio" name="evlValueType"
                                                           value="NonMarket" v-model="realEstate.evlValueType">
                                                    <span class="form-check-sign"></span>
                                                    {{$t("realEstate.valueType.nonMarket")}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="red" v-if="$v.realEstate.evlValueType.$error">
                                        {{$t("realEstate.validation.valueType")}}
                                    </div>
                                </div>
                                <template v-if="hasPermission('REAL_ESTATE_LIGHT_CONSTRUCTIVE_ELEMENT')">
                                    <div class="form-group">
                                        <div class="form-check checkbox-inline">
                                            <label class="form-check-label pl-0">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.lightConstructiveElement"
                                                       name="contractAmountByAgreement">
                                                <span class="form-check-sign"></span>
                                                Енгил конструктив элемент
                                            </label>
                                        </div>
                                    </div>
                                </template>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluatorIdea")}}</label>
                                    <textarea type="text" class="form-control"
                                              v-model="realEstate.evaluatorIdea"></textarea>
                                </div>
                                <div class="form-group">
                                    <div class="form-check checkbox-inline">
                                        <label class="form-check-label pl-0">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="realEstate.landComparisonEnabled"
                                                   name="landComparisonEnabled"
                                                   @change="handleChangeLand($event)"
                                            >
                                            <span class="form-check-sign"></span>
                                            {{$t("realEstate.field.landComparison")}}
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-check checkbox-inline">
                                        <label class="form-check-label pl-0">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="realEstate.landCapitalizationEnabled"
                                                   name="landCapitalizationEnabled"
                                                   @change="handleChangeLand($event)"
                                            >
                                            <span class="form-check-sign"></span>
                                            {{$t("realEstate.field.landCapitalization")}}
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group" v-if="realEstate.landCapitalizationEnabled">
                                    <div class="section-header">
                                        <label>{{$t("realEstate.field.landCapitalizationTitle")}}</label>
                                    </div>
                                    <div class="table-responsive">
                                      <div class="table-wrapper">
                                        <table class="table table-bordered">
                                            <thead>
                                            <th width="20%" class="text-center"><label>Ставка</label></th>
                                            <th width="20%" class="text-center"><label>Гектар</label></th>
                                            <th width="20%" class="text-center"><label>1 гектар сўммаси</label></th>
                                            <th width="5%" class="text-center"><label>Молиялаш ставкаси(%)</label></th>
                                            <th width="100%" class="text-center"><label>Баҳоси(сўм)</label></th>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td class="text-right">{{calculated.taxPerHectare}}</td>
                                                <td class="text-right">{{calculated.areaInHectare | currency('', 3, {
                                                    thousandsSeparator: ' ' })}}
                                                </td>
                                                <td class="text-right">{{calculated.landTaxAmount | currency('', 2, {
                                                    thousandsSeparator: ' ' })}}
                                                </td>
                                                <td class="text-center">{{calculated.financingRate | currency('', 2, {
                                                    thousandsSeparator: ' ' })}}
                                                </td>
                                                <td class="text-right">{{calculated.calculatedTotalLandPrice |
                                                    currency('', 2, { thousandsSeparator: ' ' })}}
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4>{{$t("realEstate.field.docsToSubmit")}}</h4>
                                </div>
                            </div>
                            <template>
                                <AssetDropZone code="cadastreDropZone" label="realEstate.field.docCadastre"
                                               folder="Cadastre" :folderName="'RealEstate'"
                                               :data="realEstate.cadastre"
                                               @change="(files) => {realEstate.cadastre = files}"
                                               :has-error="$v.realEstate.cadastre.$error"
                                               :removeFile="canSave && hasPermission('REAL_ESTATE_IMAGE_DELETE')"/>

                            </template>
                        </div>
                        <div class="row" v-if="realEstate.id && realEstate.id > 0">
                            <div class="col-12">
                                <div class="section-heade">
                                    <h4 class="pull-left">
                                        {{$t("realEstate.field.buildingsToEvaluate")}}
                                    </h4>
                                    <button class="all-btn add-btn pull-right" @click="addBuilding" v-if="canSave">
                                        {{$t("realEstate.field.addBuilding")}}
                                    </button>
                                </div>
                                <div class="table-responsive">
                                  <div class="table-wrapper">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th width="5%">№</th>
                                            <th width="20%">Бино номи</th>
                                            <th width="15%" class="text-center">Бино хажми (м3)</th>
                                            <th width="15%" class="text-center">Қурилиш ости майдони (м2)</th>
                                            <th width="15%" class="text-right">Бахоланган қиймати</th>
                                            <th width="15%" class="text-right">Қайси бинога бириктирилган</th>
                                            <th width="100%">ЖАРАЁН</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(building, index) in realEstate.buildings" :key="building.id">
                                            <td>{{index+1}}</td>
                                            <td>{{building.name}}</td>
                                            <td class="text-center">{{building.volume}} м3</td>
                                            <td class="text-center">{{building.area}} м2</td>
                                            <td class="text-right">
                                                    <!--<span v-if="building.calculated && building.calculated.price && building.calculated.price.expense">-->
                                                        <!--{{building.calculated.price.expense | currency('', 2, { thousandsSeparator: ' ' })}} сум-->
                                                    <!--</span>-->
                                                <span>{{calculateApproachTotal(building) | currency('', 2, { thousandsSeparator: ' ' })}}</span>
                                            </td>
                                            <td class="text-center">
                                                {{building.parent && building.parent.name ? building.parent.name : ''}}
                                            </td>
                                            <td class="td-actions text-center direction-row">
                                                <router-link tag="button"
                                                             :to="'/asset/real-estate/building/comparison/' + building.realEstateId + '/' + building.id"
                                                             v-tooltip="'Қиёсий ёндашув'"
                                                             class="all-btn edit-btn table-action"
                                                             v-if="realEstate.approachComparative">
                                                    <i class="fa fa-balance-scale"></i>
                                                </router-link>
                                                <router-link tag="button"
                                                             :to="'/asset/real-estate/building/comparison-income/' + building.realEstateId + '/' + building.id"
                                                             v-tooltip="'Даромад ёндашув'"
                                                             class="all-btn add-btn table-action"
                                                             v-if="realEstate.approachIncome">
                                                    <i class="fa fa-file-o"></i>
                                                </router-link>
                                                <router-link tag="button"
                                                             v-if="canSave"
                                                             :to="'/asset/real-estate/building/edit/' + building.realEstateId + '/' + building.id"
                                                             v-tooltip="'Бинони ўзгартириш'"
                                                             class="all-btn edit-btn table-action">
                                                    <i class="fa fa-edit"></i>
                                                </router-link>
                                                <button type="button" v-tooltip="'Бинони ўчириш'" v-if="canSave"
                                                        class="all-btn delete-btn table-action"
                                                        @click="showDeleteBuildingDialog(building, index)">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                  </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing"
                                        v-if="canSave">{{$t("action.save")}}
                                </button>
                                <router-link
                                        tag="button"
                                        v-tooltip="'ЭЦПни тасдиқлаш'"
                                        :to="'/real-estate/esp/' + realEstate.id"
                                        class="all-btn pull-right ml-3"
                                        v-if="hasPermission('REAL_ESTATE_CONFIRM') && realEstate.status === 'Confirmed'"
                                >
                                    {{$t("realEstate.action.espSign")}}
                                </router-link>
                            </div>
                        </div>
                        <div class="row mt-2" v-if="realEstate.status === 'Confirmed'">
                            <div class="col">
                                <div class="alert alert-warning d-flex">
                                    <i class="fa-fw fa fa-warning mr-1"></i>
                                    <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong> Тасдиқлагандан (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш тугмасини босинг!</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template>
            <b-modal v-model="show" title="Кучмас мулкни бекор қилиш">
                <div slot="modal-footer">
                    <button
                            type="button"
                            class="all-btn add-btn float-right ml-2"
                            @click="rejectAppraisal('Rejected')"
                    >{{$t("action.save")}}
                    </button>
                    <button
                            type="button"
                            class="all-btn delete-btn float-right"
                            @click="rejectModalHide"
                    >{{$t("action.cancel")}}
                    </button>
                </div>
            </b-modal>
        </template>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import {numericTypes} from '@/shared/constants/mask'
    import AssetDropZone from '@/views/asset/AssetDropZone'
    import initFilterModel from '@/shared/filter';
    import {required, requiredUnless, minValue, minLength} from 'vuelidate/lib/validators';
    import bModal from 'bootstrap-vue/es/components/modal/modal'

    export default {
        name: "RealEstateOfAssetEdit",
        components: {
            Treeselect,
            AssetDropZone,
            'b-modal': bModal
        },
        data() {
            return {
                processing: false,
                numericTypes: numericTypes,
                cadastreSectionFilter: initFilterModel(),
                show: false,
                realEstate: {
                    id: null,
                    assetItemId: ((this.$route.params.hasOwnProperty('assetItemId') && this.$route.params.assetItemId) ? this.$route.params.assetItemId : null),
                    approachCost: false,
                    approachIncome: false,
                    approachComparative: false,
                    approachRegression: false,
                    category: 'Notorious',
                    name: '',
                    cadastreDocNumber: '',
                    cadastreSections: [],

                    address: '',
                    province: {},
                    region: {},

                    evlGroundArea: 0,
                    evlBuildingWidthArea: 0,
                    evlUsefulField: 0,

                    employee: {},

                    evlValueType: 'Market',

                    landComparisonEnabled: false,
                    landCapitalizationEnabled: false,

                    buildings: [],

                    cadastre: [],// кадастр хужжати
                    status: 'Pending',
                    parentStatus: 'Pending',
                    evaluatorIdea: '',

                    landCapitalization: {
                        financingRate: 0,
                        taxPerHectare: 0,
                        calculatedTotalPrice: 0
                    },
                    sectionId: null,
                    lightConstructiveElement: false
                },
                provinces: [],
                regions: [],
                cadastreSections: [],
                employees: [],
                financingRate: 0,
                taxPerHectare: 0,
                buildingSections: []
            }
        },
        validations() {
            return {
                realEstate: {
                    approach: {
                        required: requiredUnless(() => {
                            return !(!(this.realEstate.approachCost || this.realEstate.approachComparative || this.realEstate.approachIncome));
                        })
                    },
                    name: {
                        required: required
                    },
                    cadastreDocNumber: {
                        required: required
                    },
                    // cadastreSections: {
                    //     required: required,
                    //     minLength: minLength(1)
                    // },
                    sections: {
                        required: requiredUnless( () => {
                            return !(this.isSections);
                        })
                    },
                    address: {
                        required: required
                    },

                    evlGroundArea: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlBuildingWidthArea: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlUsefulField: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlValueType: {
                        required: required
                    },
                    cadastre: {
                        required: required,
                        minLength: minLength(1)
                    }
                }
            };
        },
        computed: {
            canSave() {
                return (this.realEstate.parentStatus === 'Pending' || this.realEstate.parentStatus === 'AssignedToEvaluator' || this.realEstate.parentStatus === 'NotFullyEvaluated');
            },
            canEvaluate() {
                let hasBuildingCalculated = false;
                if (this.realEstate.status === 'NotFullyEvaluated' && this.hasPermission('REAL_ESTATE_EVALUATE')) {
                    this.realEstate.buildings.forEach((building) => {
                        if ((building.calculated && building.calculated.price && building.calculated.price.expense && building.calculated.price.expense > 0) ||
                            (building.comparison && building.comparison.calculatedTotalPrice && building.comparison.calculatedTotalPrice > 0) ||
                            (building.comparisonIncome && building.comparisonIncome.calculated &&  building.comparisonIncome.calculated.total && building.comparisonIncome.calculated.total > 0))
                        {
                            hasBuildingCalculated = true;
                        }
                    });
                }
                return hasBuildingCalculated;
            },
            canConfirm() {
                return this.realEstate.status === 'Evaluated' && this.hasPermission('REAL_ESTATE_CONFIRM');
            },
            canReEvaluate() {
                return (this.realEstate.status === 'Evaluated' || this.realEstate.status === 'Confirmed') && this.hasPermission('REAL_ESTATE_REEVALUATE');
            },
            calculated() {

                let landTaxAmount = 0;
                let financingRate = 0;
                let taxPerHectare = 0;
                let calculatedTotalLandPrice = 0;

                const areaInHectare = this.realEstate.evlGroundArea * 0.0001;

                if (this.taxPerHectare > 0) {
                    taxPerHectare = this.taxPerHectare;
                    landTaxAmount = taxPerHectare * areaInHectare;
                }
                if (this.financingRate > 0) {
                    financingRate = this.financingRate;
                    calculatedTotalLandPrice = landTaxAmount / financingRate * 100;
                }
                return {
                    financingRate: financingRate,
                    taxPerHectare: taxPerHectare,
                    areaInHectare: areaInHectare,
                    landTaxAmount: landTaxAmount,
                    calculatedTotalLandPrice: calculatedTotalLandPrice
                }
            },
            isSections() {
                return !(this.realEstate.cadastreSections && this.realEstate.cadastreSections.length > 0) && this.realEstate.approachCost
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;
                let category = '';
                if (this.$route && this.$route.meta && this.$route.meta.category && this.$route.meta.category.length > 0) {
                    category = this.$route.meta.category;
                }
                const promises = [
                    this.$http.get('admin/real-estate/init/' + ((category && category.length > 0) ? category : 'na') + '/' + ((id && id > 0) ? id : '0'))
                ];
                if (id && id > 0) {
                    promises.push(this.$http.get('admin/real-estate/' + id));
                } else {
                    vm.realEstate.category = category;
                }
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.cadastreSections = initData.cadastreSections.map((item) => {
                        item.label = item.name;
                        return item;
                    });
                    vm.buildingSections = initData.buildingSections;
                    if (values.length >= 2) {
                        const editData = values[1].data;
                        vm.realEstate = editData;

                        if (editData.landCapitalization && editData.landCapitalization.financingRate > 0 && editData.landCapitalization.taxPerHectare > 0) {
                            vm.initLandCapitalizationData(editData.landCapitalization)
                        }

                        if (vm.realEstate.region && vm.realEstate.region.id > 0) {
                            vm.initLandCapitalizationRegionChangeData()
                        } else {
                            if (vm.realEstate.province && vm.realEstate.province.id > 0) {
                                vm.initLandCapitalizationProvinceChangeData();
                            }
                        }

                        vm.initProvinceRegions();
                    }
                });
            },
            addBuilding() {
                this.$router.push('/asset/real-estate/building/new/' + this.realEstate.id);
            },
            cancel() {
                this.$router.push('/asset/item/edit/' + this.realEstate.assetItemId);
            },
            save() {
                this.saveAndGo('close');
            },
            saveAndGo(action) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;

                this.realEstate.landCapitalization = {
                    financingRate: this.calculated.financingRate,
                    taxPerHectare: this.calculated.taxPerHectare,
                    calculatedTotalPrice: this.calculated.calculatedTotalLandPrice
                };

                this.$http.post('admin/real-estate', this.realEstate)
                    .then(res => {
                        this.processing = false;
                        if (res.data.status !== 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t(res.data.message),
                                type: 'warning'
                            });
                            return;
                        }
                        if ('land' === action) {
                            this.$router.push('/asset/real-estate/land/' + res.data.data.id);
                        } else if ('coordination' === action) {
                            this.$router.push('/asset/real-estate/coordination/' + res.data.data.id);
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.success'),
                                type: 'success'
                            });
                            this.realEstate.id = res.data.data.id;
                            this.$router.push('/asset/real-estate/edit/' + res.data.data.id);
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            showDeleteBuildingDialog(building, index) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.building.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                    // cancelButtonColor: '#dd3333'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('real-estate/building/' + building.id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.building.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.realEstate.buildings.splice(index, 1);
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: this.$t(res.data.message),
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.building.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            initProvinceRegions() {
                let regions = [];
                if (this.realEstate.province && this.realEstate.province.id && this.realEstate.province.id > 0 && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.realEstate.province.id && province.regions && province.regions.length > 0) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
            },
            onProvinceChange() {
                this.initProvinceRegions();
                this.realEstate.region = {};
                if (this.realEstate.province.id > 0) {
                    this.initLandCapitalizationProvinceChangeData();
                }
            },
            handleChangeLand: function (e) {
                const name = e.target.name;
                if (this.realEstate[name]) {
                    Object.keys(this.realEstate).map((key) => {
                        if (key != name) {
                            if (key === 'landComparisonEnabled' || key === 'landCapitalizationEnabled') {
                                this.realEstate[key] = false;
                            }
                        }
                    })
                }
            },
            initLandCapitalizationProvinceChangeData() {
                const vm = this;
                this.$http.get('admin/real-estate/land-capitalization/province/' + this.realEstate.province.id)
                    .then(res => {
                        const data = res.data;
                        vm.initLandCapitalizationData(data)
                    }, err => {
                        console.log(err);
                    });
            },
            initLandCapitalizationRegionChangeData() {
                const vm = this;
                this.$http.get('admin/real-estate/land-capitalization/region/' + this.realEstate.region.id)
                    .then(res => {
                        const data = res.data;
                        vm.initLandCapitalizationData(data)
                    }, err => {
                        console.log(err);
                    });
            },
            initLandCapitalizationData(data) {
                this.financingRate = data.financingRate;
                this.taxPerHectare = data.taxPerHectare;
            },
            rejectModalHide() {
                this.show = false;
            },
            onChangeApproach(value, $event) {
                const checked = $event.target.checked;
                if (checked && value === 'Regression')  {
                    this.realEstate.approachCost = false;
                    this.realEstate.approachIncome = false;
                    this.realEstate.approachComparative = false;
                }
                if (!checked && value === 'Regression') {
                    this.realEstate.approachCost = true;
                }
                if (checked && value === 'Income') {
                    this.realEstate.approachRegression = false;
                }

                if (checked && value === 'Comparative') {
                    this.realEstate.approachRegression = false;
                }
            },
            calculateApproachTotal(building) {
                let approachTotalPrice = 0;
                if (building.calculated && building.calculated.price && building.calculated.price.expense) {
                    approachTotalPrice = approachTotalPrice + building.calculated.price.expense;
                }
                if (building.comparison && building.comparison.calculatedTotalPrice) {
                    approachTotalPrice = approachTotalPrice + building.comparison.calculatedTotalPrice;
                }
                if (building.comparisonIncome && building.comparisonIncome.calculated && building.comparisonIncome.calculated.total) {
                    approachTotalPrice = approachTotalPrice + building.comparisonIncome.calculated.total;
                }
                return approachTotalPrice;
            }
        },
        created() {
            this.cadastreSectionFilter.page.size = 10000;
            this.init();
        }
    }
</script>

<style scoped>

</style>
